import { useState } from 'react';
import { toast } from 'react-toastify';
import axios from 'axios';

const useForgotPasswordForm = callback => {
  const [loading, setLoading] = useState(false);
  const [inputs, setInputs] = useState({
    email: '',
  });
  const { email } = inputs;

  const sendForgotPassword = email => {
    setLoading(true);
    axios
      .post(
        `${process.env.REACT_APP_PUBLIC_API_URL}/validation/forgotpasswordcreate`,
        {
          email: email.toLowerCase(),
        },
        {
          headers: {
            'Content-type': 'application/json; charset=UTF-8',
          },
        },
      )
      .then(({ data }) => {
        if (data.success === true) {
          setLoading(false);
          callback(true);
        } else {
          setLoading(false);
          toast.error(data.err);
        }
      });
  };

  const handleSubmit = async event => {
    if (event) {
      event.preventDefault();
      await sendForgotPassword(email);
    }
  };
  const handleInputChange = event => {
    event.persist();
    const newInput = {
      ...inputs,
      [event.target.name]: event.target.value,
    };
    setInputs(newInput);
  };
  return {
    handleSubmit,
    handleInputChange,
    inputs,
    loading,
    sendForgotPassword,
  };
};

export default useForgotPasswordForm;
